import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { fetchItemDetailsAction, fetchMenuAction } from '@kfc-global/react-shared/redux/Actions/MenuAction';
import { getBulkStoreStatus } from '@kfc-global/react-shared/redux/Actions/StoresAction';
import { NOT_AVAILABLE, ANALYTICS_SHARED_CONSTANTS, SESSION_STORAGE_KEYS } from 'common/constants/SharedConstants';
import {
  createPayloadForStatusCall,
  getAndCheck,
  getAndCheckIfOneTrue,
  getDispositionTypeOnAPIFormat,
  getLength,
  getPrice,
  getValueOrDefaultObject,
  isEmptyObject,
  isIpadDevice,
  isMobileDevice,
  getDiscountAndCoupon,
  getValueOrEmptyString,
  getTernaryValue,
  filterExcludedItem,
  checkExclusion,
  goToMenuPage,
} from 'common/utilities/utils';
import HOME_PAGE_CONTAINER_CONSTANTS from 'components/homePageContainer/Constants/homePageContainerConstants';
import { UserOrderContext } from 'context/context';
import isEmpty from 'lodash/isEmpty';
import { checkStoreAvailablity } from 'organisms/CartPage/Presentation/EmptyCartItems';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import MenusPdpItem from 'organisms/MenuPDPPage/AU/Presentation/MenusPdpItem';
import { ViewPdpProductDetail } from 'organisms/MenuPDPPage/AU/Presentation/ReusableComponents/PdpAnalytics';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ProductState from 'organisms/MenusPLP/Presentation/ProductState';
import CustomizationAlert from 'organisms/CustomizationAlert/Container/CustomizationAlertContainer';
import ProductListingCustomComponent from 'organisms/ProductListingCustomizationComponent/Container/ProductListingCustomizationComponent';
import CartAlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import CartAlertFormInsideModel from 'molecules/Alert/Container/AlertFormInsideModel';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { getDispositionObj } from 'organisms/ScheduleOrder/ScheduleOrderUtils/ScheduleOrderUtils';
import { getIndulgentAddOnContainerSize, getImageSize } from 'organisms/CartPage/AU/Utils/cartPageUtils';
import { saveScheduleDate } from 'organisms/MenusPLP/AU/MenusPlpUtilities/MenusPlpUtils';
import { redirectToPage } from '../Utilities/MenuPDPUtils';
import { useAppSelector } from '@kfc-global/react-shared/redux/Store/hooks';
import { getPWAstorage } from '@kfc-global/react-shared/redux/Slices/PwaStorageSlice';

const getCorrectItemId = (
  correctItem,
  isFromMultiProductViewModal,
  productIdFromDetails,
  cartData,
  pdpDataForUpdateFoodLine,
) => {
  if (pdpDataForUpdateFoodLine?.foodLineId) {
    let foodLineId = pdpDataForUpdateFoodLine?.foodLineId;
    let itemMatched = cartData?.foodLines?.find(({ id }) => id === foodLineId);
    return itemMatched?.item?.id;
  } else if (isFromMultiProductViewModal) {
    return productIdFromDetails || correctItem?.[0]?.id;
  } else {
    return correctItem?.[0]?.id;
  }
};

const getStoreFlag = (storesWithStatus, CLOSED, storeId, storesTimeSlots, setIsStoreClosed) => {
  if (!isEmptyObject(storesTimeSlots)) {
    let flag = false;
    if (getLength(storesWithStatus) && storeId) {
      let storeData = storesWithStatus.filter(store => store.storeId === storeId || store.id === storeId);
      flag = getLength(storeData) && storeData[0]?.summary?.status?.currentStatus === CLOSED ? true : false;
    }
    setIsStoreClosed(flag);
  }
};

const getEntireCatNavigation = (cat_detail, flatResponse, resultString, catalog) => {
  let val = flatResponse.categoryMapById?.[cat_detail.parentID];
  if (val) {
    resultString.push({ text: val.name, url: val.url });
    getEntireCatNavigation(val, flatResponse, resultString, catalog);
  }
  return resultString.slice().reverse();
};

/* check when to call fetch item details API */
export const fetchItemDetailsCallSopac = (fetchItemDataParam, isDeepLinkURL, history) => {
  const customise_pdp_flag = sessionStorage.getItem(SESSION_STORAGE_KEYS.CUSTOMISE_PDP_FLAG);
  const {
    flatResponse,
    category_name,
    product_name,
    setIsModalOpen,
    isFromMultiProductViewModal,
    productIdFromDetails,
    cartData,
    pdpDataForUpdateFoodLine,
    isFromRecommendedSectionItemClick,
    exclusionsResponse,
  } = fetchItemDataParam;
  let selectedProductId = '',
    selectedProductName = '',
    selectedProductItems = [],
    url = '';
  const { categoryMapByUrl = {} } = flatResponse;
  /* fetch category from menuReducer using category_url from urlParams */
  const correctCategory = categoryMapByUrl?.[category_name];
  /* fetch category from menuReducer using product_url from urlParams */
  const correctProduct = correctCategory?.productMapByProductUrl?.[product_name];
  const hiddenCategoryFromDeeplink =
    (isDeepLinkURL ?? false) && (correctProduct?.isHidden || correctCategory?.isHidden);
  const redirectMenuFromHiddenCategoryFlag =
    !((isFromMultiProductViewModal ?? false) || isFromRecommendedSectionItemClick || (customise_pdp_flag ?? false)) &&
    correctCategory?.isHidden;
  sessionStorage.removeItem(SESSION_STORAGE_KEYS.CUSTOMISE_PDP_FLAG);
  const itemExcluded = checkExclusion(productIdFromDetails, exclusionsResponse, '');
  if (!isDeepLinkURL && (isEmpty(correctCategory) || isEmpty(correctProduct) || itemExcluded)) {
    setIsModalOpen(true);
  }
  if (isDeepLinkURL && (isEmpty(correctCategory) || isEmpty(correctProduct) || itemExcluded)) {
    goToMenuPage(history);
  }
  if (
    isEmpty(correctCategory) ||
    isEmpty(correctProduct) ||
    hiddenCategoryFromDeeplink ||
    redirectMenuFromHiddenCategoryFlag
  ) {
    const hiddenCategoryFlag = redirectMenuFromHiddenCategoryFlag;
    !isDeepLinkURL && hiddenCategoryFlag && setIsModalOpen(true);
    return false;
  }

  if (isEmptyObject(correctProduct)) {
    /* fetch items from selected product */
    const correctItems = Object.values(correctProduct.itemMapByItemId);
    selectedProductId = getCorrectItemId(
      correctItems,
      isFromMultiProductViewModal,
      productIdFromDetails,
      cartData,
      pdpDataForUpdateFoodLine,
    );
    selectedProductName = correctProduct.dname;
    selectedProductItems = correctItems;
    url = correctProduct.url;
  }
  return {
    id: selectedProductId,
    name: selectedProductName,
    items: selectedProductItems,
    url,
    categoryName: correctCategory?.name,
    categoryId: correctCategory?.id,
  };
};

/* breadcrumb display message */
export const displayBreadcrumbPDPSopac = (category_id, flatResponse, catalogs) => {
  const cat_detail = flatResponse?.categoryMapById?.[category_id];
  return cat_detail
    ? getEntireCatNavigation(
        cat_detail,
        flatResponse,
        [{ text: cat_detail.dname?.[0]?.value, url: cat_detail.url }],
        catalogs,
      )
    : [];
};
/* method to check for catalog & serviceType availablity to decide MenuApi call */
export const checkForCatalogServiceType = (catalogs, serviceType, tenantData) => {
  return catalogs === tenantData?.genericMenuName || (catalogs && serviceType);
};

const menusPdpItemView = menuPdpPayloadData => {
  const {
    productObject,
    tenantObject,
    isMobile,
    category_id,
    product_name,
    flatResponse,
    isStoreClosed,
    catalogs,
    isIpad,
    segmentedHomePageData,
    selectedProduct,
    showLegalInfo,
    dispositionType,
    imageContainerSize,
    indulgentImageContainerSize,
    storesWithStatus,
    updatedFetchMenuPayload,
  } = menuPdpPayloadData;
  const storeTimeZone = storesWithStatus && storesWithStatus[0]?.summary?.timeZoneIANA;
  let menuPDPItemData = {
    tenantData: tenantObject,
    isIpad,
    productDetails: productObject,
    prodName: selectedProduct.selectedProductName,
    prodItems: selectedProduct.selectedProductItems,
    prodURL: selectedProduct.url,
    categoryName: selectedProduct.selectedCategoryName,
    categoryUrl: selectedProduct.selectedCategoryUrl,
    isMobile,
    dispositionType,
    displayBreadcrumbPDP: displayBreadcrumbPDPSopac(category_id, flatResponse, catalogs),
    isStoreClosed,
    product_name,
    segmentedHomePageData,
    showLegalInfo,
    storeTimeZone,
    imageContainerSize,
    indulgentImageContainerSize,
    updatedFetchMenuPayload,
    catalogs,
  };
  return (
    <div className='pdp-container pdp-container-sopac'>
      {productObject && tenantObject?.tenantId && <MenusPdpItem menuPDPItemData={menuPDPItemData} />}
    </div>
  );
};

export const setExcludedFlag = (currentItemDetails, exclusionsResponse, EXCLUDED, NA) => {
  if (currentItemDetails?.id) {
    currentItemDetails[EXCLUDED] = checkExclusion(currentItemDetails?.id, exclusionsResponse, NA);
  }
  currentItemDetails?.modgrps?.map(modG => {
    modG?.modifiers?.map(modifiers => {
      modifiers[EXCLUDED] = checkExclusion(modifiers?.id, exclusionsResponse, NA);
      modifiers?.modgrps?.map(l3Modg => {
        l3Modg?.modifiers?.map(l3modifiers => {
          l3modifiers[EXCLUDED] = checkExclusion(l3modifiers.id, exclusionsResponse, NA);
          return l3modifiers;
        });
        return l3Modg;
      });
      return modifiers;
    });
    return modG;
  });
  return currentItemDetails;
};

export const getModelValue = getPwaStorageData => {
  return getPwaStorageData?.pdpAlertPopup ?? false;
};

const MenuPDPContainer = props => {
  const { tenantData, contentData, match, history, setStoreClosedInfo, segmentedHomePageData } = props;
  const { params } = match;
  const { category_name = '', product_name = '' } = params;
  const { storeInfo, dispositionType, catalogs, isFromCatering } = contentData;
  const { tenantId, currencyConversionFactor, country, componentOptions = { web: { pdp: {} } } } = tenantData;
  const { enableScheduleOrder = false, enableClickCollectScheduleOrder = false } =
    componentOptions?.web?.dispositionConfig;
  const allowScheduleOrderForDispositions =
    componentOptions?.web?.scheduledDelivery?.allowScheduleOrderForDispositions ?? [];
  const enableScheduleOrderFlag = enableScheduleOrder || enableClickCollectScheduleOrder;
  const {
    web: {
      pdp: { showLegalInfo = false },
      shouldCheckDropOffAddress = false,
    },
  } = componentOptions;
  const {
    SET_PDP_DEEPLINK_MODE,
    RESET_MODGROUP_IDS_UPDATE,
    PDP_PAYLOAD_DATA,
    RESET_SHOW_PDP_CUSTOM_MODAL,
    PDP_ITEM_UPSIZE_ID,
    BROWSE_MENU_TITLE,
    ITME_NOT_AVAILABLE,
    BROWSE_MENU,
    EXCLUDED,
    NA,
  } = MENU_PDP_PAGE_CONSTANTS;
  const { PLP_PDP_DETAILS, CLOSED } = START_ORDER_CONSTANTS;
  const { userOrderStateDispatch, userOrderState } = useContext(UserOrderContext);
  const {
    pdpDeepLinking,
    ProductDetails,
    pdpItemUpsizeId,
    isFromMultiProductViewModal,
    isFromRecommendedSectionItemClick,
    sopacPDPCustomization,
    scheduleOrderData,
    pdpDataForUpdateFoodLine,
  } = userOrderState;
  const { changeFlow = false, isAddressFlow = false } = scheduleOrderData;
  const { showPDPCustomization } = sopacPDPCustomization;
  const { isFromPlp = false } = getValueOrDefaultObject(ProductDetails);
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const [isIpad, setIPadHeader] = useState(isIpadDevice());
  const [product_id, setProductID] = useState('');
  const [selectedProduct, setSelectedProduct] = useState({});
  const [category_id, setCategoryId] = useState('');
  const productDetails = useMemo(() => {
    return isEmptyObject(ProductDetails) ? ProductDetails : {};
  }, [ProductDetails]);
  const { SERVICE_CHANNEL } = HOME_PAGE_CONTAINER_CONSTANTS;
  const storeId = getValueOrEmptyString(storeInfo?.id);
  const serviceType = dispositionType;
  const dispatch = useDispatch();
  const currentItemDetails = useSelector(({ menuReducer: { currentItemDetails } }) => currentItemDetails);
  const flatResponse = useSelector(({ menuReducer: { flatResponse } }) => flatResponse);
  const menuReducer = useSelector(({ menuReducer }) => menuReducer);
  const storesReducer = useSelector(data => data.storesReducer);
  const { storesTimeSlots, storesWithStatus } = storesReducer;
  const { cartReducer } = useSelector(data => data);
  const { cartData = {} } = getValueOrDefaultObject(cartReducer);
  const [isStoreClosed, setIsStoreClosed] = useState();
  const getPwaStorageData = useAppSelector(getPWAstorage);
  const [isModalOpen, setIsModalOpen] = useState(getModelValue(getPwaStorageData));
  const [imageContainerSize, setImageContainerSize] = useState({ containerHeight: 0, containerWidth: 0 });
  const [indulgentImageContainerSize, setIndulgentImageContainerSize] = useState({
    containerHeight: 0,
    containerWidth: 0,
  });
  const { CartError } = IMAGE_PATH;
  const showOrderNow = cartData?.requestedDateTime?.isForNow;
  let fetchMenuPayload = { storeId: storeId, channel: SERVICE_CHANNEL, service: serviceType };
  const scheduleOrderObject = { enableScheduleOrderFlag, showOrderNow, allowScheduleOrderForDispositions };
  const updatedFetchMenuPayload = saveScheduleDate(fetchMenuPayload, serviceType, scheduleOrderObject);
  const getExclusionResponse = menuReducer?.exclusionsResponse;
  const catalogName = storesWithStatus?.[0]?.summary?.menu?.catalogs?.[0] || catalogs;
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    const isIPadWidth = isIpadDevice();

    setMobileHeader(isMobileView);
    setIPadHeader(isIPadWidth);

    const imageSize = getImageSize(isMobileView);
    setImageContainerSize(imageSize);
    const indulgentImageSize = getIndulgentAddOnContainerSize(isMobileView, window.innerWidth);
    setIndulgentImageContainerSize({
      containerHeight: indulgentImageSize.containerHeight,
      containerWidth: indulgentImageSize.containerWidth,
    });
  };
  const viewPdpProductDetail = () => {
    if (isEmptyObject(productDetails)) {
      const discountLinesObj = getDiscountAndCoupon(cartData);
      const { couponCode = '', amount = '' } = getValueOrDefaultObject(discountLinesObj);

      const correctCategory = flatResponse?.categoryMapByUrl?.[category_name];
      const categoryName = correctCategory?.name;
      const analyticsArray = [
        {
          item_name: getAndCheckIfOneTrue(productDetails?.productInfo?.productName[0]?.value, NOT_AVAILABLE),
          item_id: getAndCheckIfOneTrue(productDetails?.productId, NOT_AVAILABLE),
          price: getAndCheckIfOneTrue(productDetails?.productInfo?.productPrice, NOT_AVAILABLE),
          coupon: couponCode,
          currency: ANALYTICS_SHARED_CONSTANTS.AUD,
          discount: amount,
          item_category: getAndCheckIfOneTrue(categoryName, NOT_AVAILABLE),
          item_list_name: ANALYTICS_SHARED_CONSTANTS.PDP_UPSELL,
          item_list_id: getAndCheckIfOneTrue(productDetails?.categoryId, NOT_AVAILABLE),
          index: 1,
          quantity: 1,
        },
      ];
      ViewPdpProductDetail(analyticsArray);
    }
  };

  useEffect(() => {
    windowResized();
    userOrderStateDispatch({ type: RESET_MODGROUP_IDS_UPDATE });
    window.scrollTo(0, 0);
    userOrderStateDispatch({
      type: SET_PDP_DEEPLINK_MODE,
      value: { pdpDeepLinking: !isFromPlp },
    });

    /* check for store closed behaviour */
    viewPdpProductDetail();
    return () => {
      setProductID('');
      setSelectedProduct({});
      userOrderStateDispatch({ type: PDP_PAYLOAD_DATA, value: {} });
      userOrderStateDispatch({ type: RESET_SHOW_PDP_CUSTOM_MODAL });
      userOrderStateDispatch({ type: PDP_ITEM_UPSIZE_ID, value: { pdpItemUpsizeId: '' } });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* useeffect for checking available time slots for store */
  useEffect(() => {
    if (isEmptyObject(storesTimeSlots)) {
      const currentStoreInfo = { ...storeInfo, summary: storesTimeSlots };
      const {
        futureDates,
        scheduled: initiallyScheduled,
        asap,
      } = getValueOrDefaultObject(currentStoreInfo?.summary?.timings);
      const { unavailibilities } = getValueOrDefaultObject(initiallyScheduled);
      const { interval: initialInterval = 0, startEndTime = {} } = getValueOrDefaultObject(
        initiallyScheduled?.periods?.length && initiallyScheduled?.periods[0],
      );
      const { from, to } = startEndTime;
      const availableSlots = checkStoreAvailablity(
        from,
        to,
        initialInterval,
        asap,
        futureDates,
        country,
        unavailibilities,
      );
      if (storesTimeSlots?.status?.currentStatus === CLOSED && !availableSlots.length) {
        setStoreClosedInfo(currentStoreInfo);
        setIsStoreClosed(true);
        redirectToPage(isFromCatering, history);
      } else {
        setIsStoreClosed(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storesTimeSlots]);

  const callStatusAPIData = (storeListData, serviceTypeData) => {
    const data = createPayloadForStatusCall(storeListData, serviceTypeData, null, shouldCheckDropOffAddress);
    const statusCallPayload = {
      data,
      store: storeListData,
      tenantId: tenantId,
      setStatusFlag: false,
      isFavoritePage: false,
    };
    dispatch(getBulkStoreStatus(statusCallPayload));
  };

  useEffect(() => {
    //call menu api dispatch
    checkForCatalogServiceType(catalogName, serviceType, tenantData) &&
      dispatch(
        fetchMenuAction(
          {
            tenantId: tenantId,
            catalogName,
          },
          updatedFetchMenuPayload,
        ),
      );
    if (storeId && serviceType && !isFromPlp) {
      callStatusAPIData(
        [storeInfo],
        getDispositionTypeOnAPIFormat(getDispositionObj(changeFlow, isAddressFlow, serviceType)?.dispositionValue),
      );
    }
    getStoreFlag(storesWithStatus, CLOSED, storeId, storesTimeSlots, setIsStoreClosed);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeId, serviceType]);

  useEffect(() => {
    if (product_id !== '') {
      if (
        getAndCheckIfOneTrue(
          getAndCheck(product_id === currentItemDetails?.id, pdpDeepLinking),
          pdpItemUpsizeId === currentItemDetails?.id,
        )
      ) {
        let productInfo = {
          productImage: currentItemDetails?.imageName,
          productName: currentItemDetails?.dname,
          productPrice: getPrice(currentItemDetails?.availability[0], currencyConversionFactor),
        };
        const ProductDetailsObj = {
          productId: currentItemDetails?.id,
          customizable: currentItemDetails?.customizable,
          categoryId: category_id,
          catalogName: menuReducer?.response?.id,
          productInfo: productInfo,
          isFromPlp,
        };

        userOrderStateDispatch({
          type: PLP_PDP_DETAILS,
          value: ProductDetailsObj,
        });
      }
      //set updated product id on upsize click
      if (pdpItemUpsizeId === currentItemDetails?.id) {
        setProductID(pdpItemUpsizeId);
      }
      // seting excluded flag in modifier items

      if (menuReducer?.exclusionsResponse?.length > 0) {
        setExcludedFlag(currentItemDetails, menuReducer?.exclusionsResponse, EXCLUDED, NA);
        currentItemDetails?.recommendationRules?.forEach(recommendationRule => {
          filterExcludedItem(recommendationRule?.recommendedItems, menuReducer?.exclusionsResponse, NA);
        });
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(currentItemDetails), product_id]);

  useEffect(() => {
    if (isEmptyObject(flatResponse)) {
      const fetchItemDataParam = {
        flatResponse,
        category_name,
        product_name,
        setIsModalOpen,
        isFromMultiProductViewModal,
        isFromRecommendedSectionItemClick,
        productIdFromDetails: productDetails?.productId,
        cartData,
        pdpDataForUpdateFoodLine,
        exclusionsResponse: menuReducer?.exclusionsResponse,
      };
      const selectedProductData = fetchItemDetailsCallSopac(fetchItemDataParam, userOrderState?.isDeepLinkURL, history);
      const { categoryId = '', categoryName = '', id, name, url, items } = selectedProductData;
      const selectedProductId = id;
      console.log(selectedProductId, 'selectedProductId');
      if (selectedProductId) {
        setCategoryId(categoryId);
        setProductID(selectedProductId);
        setSelectedProduct({
          selectedProductName: name,
          selectedProductItems: items,
          url,
          selectedCategoryName: categoryName,
          selectedCategoryUrl: category_name,
        });
        userOrderStateDispatch({ type: PDP_ITEM_UPSIZE_ID, value: { pdpItemUpsizeId: selectedProductId } });
        dispatch(
          fetchItemDetailsAction({
            tenantId: tenantId,
            catalogName,
            itemId: selectedProductId,
          }),
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(flatResponse), pdpDeepLinking, product_name, getExclusionResponse]);

  const handleClose = () => {
    redirectToPage(isFromCatering, history);
    setIsModalOpen(false);
  };
  const menusPdpItemViewPayload = {
    productObject: productDetails,
    tenantObject: tenantData,
    isMobile,
    category_id,
    product_name,
    flatResponse,
    isStoreClosed,
    catalogs,
    isIpad,
    segmentedHomePageData,
    selectedProduct,
    showLegalInfo,
    dispositionType,
    imageContainerSize,
    indulgentImageContainerSize,
    storesWithStatus,
    updatedFetchMenuPayload,
  };
  return (
    <React.Fragment>
      {getTernaryValue(
        getAndCheck(imageContainerSize.containerHeight, indulgentImageContainerSize.containerHeight),
        menusPdpItemView(menusPdpItemViewPayload),
        <></>,
      )}
      {userOrderState.addToCart && userOrderState.isLocalized && userOrderState.fromPdpPage && (
        <ProductState flatResponse={flatResponse} tenantReducer={tenantData} />
      )}
      {userOrderState.cartAlertData?.showCartAlert && <CustomizationAlert />}
      {showPDPCustomization && <ProductListingCustomComponent />}
      {isModalOpen ? (
        <CartAlertFormInsideModel
          handleClose={handleClose}
          classNames='clear-cart-modal item-unavailable'
          CartAlertForm={
            <CartAlertForm
              title={translateWithI18Next(ITME_NOT_AVAILABLE)}
              contentMsg={translateWithI18Next(BROWSE_MENU_TITLE)}
              imageSrc={CartError}
              altText={translateWithI18Next(BROWSE_MENU)}
              confirmButtonText={translateWithI18Next(BROWSE_MENU)}
              confirmHandler={handleClose}
            />
          }
        />
      ) : null}
    </React.Fragment>
  );
};
export default MenuPDPContainer;
